<script>
  import { onMount } from "svelte"
  import Footer from './partials/Footer.svelte'
  import Glide from '@glidejs/glide'
  import Headline from './partials/Headline.svelte'
  import Header from "./Header.svelte"
  import Modal from "./Modal.svelte"
  import Topbar from "./Topbar.svelte"
  import {analytics, trackIt, postTracking, secondsToMins} from "../global"

  export let user = false

  let is_active = '', url = '', index = false, running = 0, company = '', companies = []
  let loading = true, timer = false, glide, speed = 4000
  let links = [{
	id: 'gallery',
	slug: 'Collections',
	href: 'gallery'
	},{
	id: 'configurator',
	slug: 'Configurator',
	href: 'configurator'
  }]
  let secStyle = "section py-12 flex flex-col justify-center mx-auto min-h-screen"
  
  onMount(() => {
	let hash = window.location.hash
	user = JSON.parse(document.head.querySelector("[name=user]").content)
	if(user){
	  getTracking(user)
	  getCompany(user)
	  if(user.user_level_id ===3){
		  getCompanies()
	  }
	}
	if(hash) {
	  let anchor = document.querySelector(`[data-section="${hash.substr(1)}"]`)
	  if(anchor) anchor.click()
	}
	jQuery(function(){
	  jQuery("#container").scrollToSection({childList: ".section"})
	  glide = new Glide('.glide', { autoplay: speed }).mount()
	})
  })

  export function unsetTimer(index){
	clearInterval(timer)//This will do less than an hour. We doubt we'll need an hour for promos
	let time = ''
	let old = user.tracking['time_video__'+index]
	if(old && old != '00:00:00'){
	  time = secondsToMins(parseInt(old.substr(3,2)) + running)
	}else{
	  time = secondsToMins(running)
	}
	analytics.logEvent('time_video__'+index, time)
	user.tracking['time_video__'+index] = time
	postTracking(user)
	running = 0
  }

  export function unsetModal(){
	url = false
	index = false
	glide.update({ autoplay: speed })
  }

  function openModal(event){
	event.preventDefault()
	glide.update({ autoplay: false })
	let modal = document.querySelector('[data-modal]')
	if(modal){
	  modal.classList.add('opacity-0')
	  modal.classList.remove('hidden')
	  setTimeout(() => {
		let is_anchor = event.target.tagName === 'A' 
		url = is_anchor ? event.target.href : event.target.dataset.href
		index = event.target.dataset.index
		modal.classList.remove('opacity-0')

		timer = setInterval(() => {
		  running++
		}, 1000)

		trackIt(event,user)
	  }, 300)
	}
  }
  
  //Pull down all tracking info for a specific user
  function getTracking(user){
	const xhr = new XMLHttpRequest();
  
	xhr.onload = () => {
	  if (xhr.status == 200) {
		user.tracking = JSON.parse(xhr.response)
		loading = false
	  } else {
		console.error('Error!')
	  }
	}
  
	xhr.open('GET', '/resource/tracking/'+user.tracking_id)
	xhr.send()
  }
  
  //Pull down the comany name for a specific user
  function getCompany(user){
	const xhr = new XMLHttpRequest();
  
	xhr.onload = () => {
	  if (xhr.status == 200) {
		company = JSON.parse(xhr.response).name
		loading = false
	  } else {
		console.error('Error!')
	  }
	}
  
	xhr.open('GET', '/resource/company/'+user.company_id)
	xhr.send()
  }

  function getCompanies(callback=false){
	const xhr = new XMLHttpRequest()

	xhr.onload = () => {
	  if (xhr.status == 200) {
	  	loading = false
	  	companies = JSON.parse(xhr.response)
	  	if(callback) callback()
	  } else {
	  	feedback = {
		  msg: 'Error!',
		  style: 'bg-poppy text-white opacity-0 delay-300'
	  	}
	  }
  	}

	xhr.open('GET', '/resource/company')
	xhr.send()
  }

  //Change from the Story section to the Configurator section
  export function switchSection(event){
    is_active = event.detail.text
  }
</script>
<style>
  iframe {
	max-height: calc(100vh - 20rem)
  }
  @media only screen and (min-width:48em) {
	iframe {
	  max-height: 67.5vh;
	  height: 50vw;
	}
  }
</style>
<Topbar user={user} page={"player"}/>
<Header links={links} is_active={is_active} user={user} page={'player'} on:message={switchSection}/>
<div class="flex items-center justify-center h-screen">
  <div id="container" data-container class="flex flex-nowrap flex-col overflow-auto w-full h-screen" dir="ltr"
   on:scroll={evt => {
	let position = evt.target.scrollTop/evt.target.offsetHeight
	if(Number.isInteger(position)){
	  if(position > 0){
		is_active = links[position - 1].href
	  	if(user.tracking_id){
		  analytics.logEvent('scrollto_section', {
			firebase_screen: is_active, 
			firebase_screen_class: 'anchor'
		  })
		}
	  }else{
		is_active = 'top'
	  	if(user.tracking_id){
		  analytics.logEvent('scrollto_top', {
			firebase_screen: is_active, 
			firebase_screen_class: 'anchor'
		  })
		}
	  }
	  if(user.tracking_id){
		user.tracking['scrollto_'+is_active] += 1
		postTracking(user)
	  }
	}
   }}>
	<!--Introduction Video Section-->
	<section class="px-4 sm:px-6 lg:px-12 {secStyle}" id="top">
	  <Headline loading={loading} iStyle="2xl:max-w-3xl xl:max-w-lg w-full mx-auto" h1={["Welcome to","Pangea Oneness"]}/>
	  <div class="2xl:max-w-2xl max-w-xl w-full mx-auto text-gray-100 mt-6">
	  	<p class="font-body md:text-lg mb-4 md:mb-6">Join us for Pangea Oneness &mdash; a journey designed to elicit inspiration and provoke new thinking about the inherent natural beauty of leather.</p>
	  	<p class="font-body md:text-lg">This one&ndash;hour journey will offer both virtual and hands-on experiences with Pangea's latest, most innovative colors, designs and patterns for leather &mdash; designs that build an emotional and technical connection between sustainability and innovation.</p>
		<a class="animate-pulse transition ease-in-out flex items-center mt-6 md:mt-10 mb-20 md:mb-40 text-poppy hover:text-shearling focus:text-shearling font-display text-xl md:2xl"
		 on:click={openModal} data-tracking="view_video__homepage" href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__homepage.mp4?alt=media">
		  <span class="pointer-events-none">Watch our brand film</span>
		  <svg width="80" height="6" fill="currentColor" class="w-16 h-3 ml-6 pointer-event-none">
			<use xlink:href="#icon__arrow_right"/>
		  </svg>
		</a>
	  </div>
	</section>
	<!--Gallery Section-->
	<section class="glide {secStyle}" id="gallery">
	  <div class="glide__track" data-glide-el="track">
	  	<div class="w-full glide__slides">
		  <div class="glide__slide">
			<h2 class="sm:flex justify-center font-display text-lg sm:text-xl lg:text-2xl text-poppy mb-4 leading-5">
			  <span class="ml-4 lg:-ml-8 w-full sm:w-4/5">Healing. Longevity. Authenticity.</span>
			</h2>
			<figure class="sm:flex justify-center">
			  <button data-href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__crafted_classics.mp4?alt=media" data-index="0" data-tracking="view_video__0" on:click={openModal} aria-label="Open video__crafted_classics.mp4"
			   class="flex flex-col justify-center items-center relative mb-4 sm:mb-auto w-full sm:w-2/5 bg-cover" style="background-image:url(https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/bg__field_of_grass--thumb.png?alt=media)">
				<svg class="w-10 sm:w-12 m-auto py-2 sm:py-10 md:py-24 pointer-events-none" fill="rgba(246, 243, 233, 0.6)">
				  <use xlink:href="#icon__play"/>
				</svg>
			  </button>
			  <figcaption class="px-4 sm:p-0 sm:ml-8 sm:w-2/5 space-y-1 sm:space-y-2 sm:space-y-4 justify-content-start flex flex-col">
				<h3 class="flex items-center font-display text-white text-lg uppercase">01<hr class="mx-2 w-10">Crafted Classics</h3>
				<p class="relative flex justify-start items-start font-body text-gray-100 text-sm sm:text-md lg:text-lg">Made by nature. Crafted by hand. One of the oldest upcycling stories in history is reinvigorated with these classic designs that convey longevity and authentity. Crafted with an artisan's touch. Explore warm, natural classic hues, open grains and all 100% natural. Classic never goes out of style.</p>
				<a href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__crafted_classics.mp4?alt=media" data-tracking="view_video__0" data-index="0" on:click={openModal}
				 class="animate-pulse transition ease-in-out flex items-center sm:text-lg text-poppy hover:text-shearling focus:text-shearling font-display">
				  <span class="pointer-events-none">Watch Film</span>
				  <svg width="80" height="10" fill="currentColor" class="ml-2 pointer-events-none">
					<use xlink:href="#icon__arrow_right"/>
				  </svg>
				</a>
			  </figcaption>
			</figure>
		  </div>
		  <div class="glide__slide">
			<h2 class="sm:flex justify-center font-display text-lg sm:text-xl lg:text-2xl text-poppy mb-4 leading-5">
			  <span class="ml-4 lg:-ml-8 w-full sm:w-4/5">Opulence. Restorative Comfort. Alluring.</span>
			</h2>
			<figure class="sm:flex justify-center">
			  <button data-href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__everyday_luxury.mp4?alt=media" data-index="1" data-tracking="view_video__1" on:click={openModal} aria-label="Open video__everyday_luxury.mp4"
			   class="flex flex-col justify-center items-center relative mb-4 sm:mb-auto w-full sm:w-2/5 bg-cover" style="background-image:url(https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/background__fpo_mesh_swatch--thumb.jpg?alt=media)">
				<svg class="w-10 sm:w-12 m-auto py-2 sm:py-10 md:py-24 pointer-events-none" fill="rgba(246, 243, 233, 0.6)">
				  <use xlink:href="#icon__play"/>
				</svg>
			  </button>
			  <figcaption class="px-4 sm:p-0 sm:ml-8 sm:w-2/5 space-y-1 sm:space-y-2 sm:space-y-4 justify-content-start flex flex-col">
				<h3 class="flex items-center font-display text-white text-lg uppercase">02<hr class="mx-2 w-10">Everyday Luxury</h3>
				<p class="relative flex justify-start items-start font-body text-gray-100 text-sm sm:text-md lg:text-lg">Perhaps it is because we are so far removed from nature so much of the time, it is easy to forget how luxurious something real feels. The pieces in this collection are a reminder. Comforting, restorative and alluring. Soft and clean pastels combined with richer, jewel tones with a mix of smooth and heavy pebbled grains.</p>
				<a href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__everyday_luxury.mp4?alt=media" data-tracking="view_video__1" data-index="1" on:click={openModal}
				 class="animate-pulse transition ease-in-out flex items-center sm:text-lg text-poppy hover:text-shearling focus:text-shearling font-display">
				  <span class="pointer-events-none">Watch Film</span>
				  <svg width="80" height="10" fill="currentColor" class="ml-2 pointer-events-none">
					<use xlink:href="#icon__arrow_right"/>
				  </svg>
				</a>
			  </figcaption>
			</figure>
		  </div>
		  <div class="glide__slide">
			<h2 class="sm:flex justify-center font-display text-lg sm:text-xl lg:text-2xl text-poppy mb-4 leading-5">
			  <span class="ml-4 lg:-ml-8 w-full sm:w-4/5">Futuristic. Metaverse. Hyper Digital.</span>
			</h2>
			<figure class="sm:flex justify-center">
			  <button data-href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__super_nature.mp4?alt=media" data-index="2" data-tracking="view_video__2" on:click={openModal} aria-label="Open video__super_nature.mp4"
			   class="flex flex-col justify-center items-center relative mb-4 sm:mb-auto w-full sm:w-2/5 bg-cover" style="background-image:url(https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/background__leather_corner--thumb.png?alt=media)">
				<svg class="w-10 sm:w-12 m-auto py-2 sm:py-10 md:py-24 pointer-events-none" fill="rgba(246, 243, 233, 0.6)">
				  <use xlink:href="#icon__play"/>
				</svg>
			  </button>
			  <figcaption class="px-4 sm:p-0 sm:ml-8 sm:w-2/5 space-y-1 sm:space-y-2 sm:space-y-4 justify-content-start flex flex-col">
				<h3 class="flex items-center font-display text-white text-lg uppercase">03<hr class="mx-2 w-10">Super Nature</h3>
				<p class="relative flex justify-start items-start font-body text-gray-100 text-sm sm:text-md lg:text-lg">Exploring a vision of the future, enhanced by technology but grounded by emotion. You'll see movement and energy in the pieces in this collection. It shows how we can live in two worlds. Reality, meet escapism. This collection is inspired by a nature enthused palette, shades of greens mixed with unexpected colors and pops of metallic.</p>
				<a href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__super_nature.mp4?alt=media" data-tracking="view_video__2" data-index="2" on:click={openModal}
				 class="animate-pulse transition ease-in-out flex items-center sm:text-lg text-poppy hover:text-shearling focus:text-shearling font-display">
				  <span class="pointer-events-none">Watch Film</span>
				  <svg width="80" height="10" fill="currentColor" class="ml-2 pointer-events-none">
					<use xlink:href="#icon__arrow_right"/>
				  </svg>
				</a>
			  </figcaption>
			</figure>
		  </div>
		  <div class="glide__slide">
			<h2 class="sm:flex justify-center font-display text-lg sm:text-xl lg:text-2xl text-poppy mb-4 leading-5">
			  <span class="ml-4 lg:-ml-8 w-full sm:w-4/5">Brave. Bold. Modern.</span>
			</h2>
			<figure class="sm:flex justify-center">
			  <button data-href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__supercharded_simplicity.mp4?alt=media" data-index="3" data-tracking="view_video__3" on:click={openModal} aria-label="Open video__supercharded_simplicity.mp4"
			   class="flex flex-col justify-center items-center relative mb-4 sm:mb-auto w-full sm:w-2/5 bg-cover" style="background-image:url(https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/background__fpo_hand_folding--thumb.jpg?alt=media)">
				<svg class="w-10 sm:w-12 m-auto py-2 sm:py-10 md:py-24 pointer-events-none" fill="rgba(246, 243, 233, 0.6)">
				  <use xlink:href="#icon__play"/>
				</svg>
			  </button>
			  <figcaption class="px-4 sm:p-0 sm:ml-8 sm:w-2/5 space-y-1 sm:space-y-2 sm:space-y-4 justify-content-start flex flex-col">
				<h3 class="flex items-center font-display text-white text-lg uppercase">04<hr class="mx-2 w-10">Supercharged Simplicity</h3>
				<p class="relative flex justify-start items-start font-body text-gray-100 text-sm sm:text-md lg:text-lg">A revolution in the mobility industry is being electrified. As we push for progress in times of uncertainty we offer a collection that is brave and bold. It features smooth grains that are soft and subtle with a mix of cool, warm and saturated bright colors to leave you feeling supercharged.</p>
				<a href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__supercharded_simplicity.mp4?alt=media" data-tracking="view_video__3" data-index="3" on:click={openModal}
				 class="animate-pulse transition ease-in-out flex items-center sm:text-lg text-poppy hover:text-shearling focus:text-shearling font-display">
				  <span class="pointer-events-none">Watch Film</span>
				  <svg width="80" height="10" fill="currentColor" class="ml-2 pointer-events-none">
					<use xlink:href="#icon__arrow_right"/>
				  </svg>
				</a>
			  </figcaption>
			</figure>
		  </div>
		  <div class="glide__slide">
			<h2 class="sm:flex justify-center font-display text-lg sm:text-xl lg:text-2xl text-poppy mb-4 leading-5">
			  <span class="ml-4 lg:-ml-8 w-full sm:w-4/5">Luminescent. Restorative. Striking.</span>
			</h2>
			<figure class="sm:flex justify-center">
			  <button data-href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__cyber_ice.mp4?alt=media" data-index="4" data-tracking="view_video__4" on:click={openModal} aria-label="Open video__cyber_ice.mp4"
			   class="flex flex-col justify-center items-center relative mb-4 sm:mb-auto w-full sm:w-2/5 bg-cover" style="background-image:url(https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/background__gentlman_w_glasses_smiling--thumb.jpg?alt=media)">
				<svg class="w-10 sm:w-12 m-auto py-2 sm:py-10 md:py-24 pointer-events-none" fill="rgba(246, 243, 233, 0.6)">
				  <use xlink:href="#icon__play"/>
				</svg>
			  </button>
			  <figcaption class="px-4 sm:p-0 sm:ml-8 sm:w-2/5 space-y-1 sm:space-y-2 sm:space-y-4 justify-content-start flex flex-col">
				<h3 class="flex items-center font-display text-white text-lg uppercase">05<hr class="mx-2 w-10">Cyber Ice</h3>
				<p class="relative flex justify-start items-start font-body text-gray-100 text-sm sm:text-md lg:text-lg">This collection connects to the state of our planet today and how as a society we are recreating and redefining a collective, regenerative approach to sustainability. Crisp icy hues, digital blues and cool yellows are based on the luminescence of an arctic sky as well as cyber space.</p>
				<a href="https://firebasestorage.googleapis.com/v0/b/pangea-458cd.appspot.com/o/video__cyber_ice.mp4?alt=media" data-tracking="view_video__4" data-index="4" on:click={openModal}
				 class="animate-pulse transition ease-in-out flex items-center sm:text-lg text-poppy hover:text-shearling focus:text-shearling font-display">
				  <span class="pointer-events-none">Watch Film</span>
				  <svg width="80" height="10" fill="currentColor" class="ml-2 pointer-events-none">
					<use xlink:href="#icon__arrow_right"/>
				  </svg>
				</a>
			  </figcaption>
			</figure>
		  </div>
		</div>
		<nav class="flex justify-center items-center mt-6">
		  <div class="h-7" data-glide-el="controls[nav]">
		  	<button class="glide__bullet" aria-label="Navigation Bullet 1"
		   	 data-glide-dir={'=0'} data-index="0" data-tracking="gallery_bullet__1"
		   	 on:click={trackIt}></button>
			<button class="glide__bullet" aria-label="Navigation Bullet 2"
			 data-glide-dir={'=1'} data-index="1" data-tracking="gallery_bullet__2"
			 on:click={trackIt}></button>
			<button class="glide__bullet" aria-label="Navigation Bullet 3"
			 data-glide-dir={'=2'} data-index="2" data-tracking="gallery_bullet__3"
			 on:click={trackIt}></button>
			<button class="glide__bullet" aria-label="Navigation Bullet 4"
			 data-glide-dir={'=3'} data-index="3" data-tracking="gallery_bullet__4"
			 on:click={trackIt}></button>
			 <button class="glide__bullet" aria-label="Navigation Bullet 5"
			  data-glide-dir={'=4'} data-index="4" data-tracking="gallery_bullet__5"
			  on:click={trackIt}></button>
		  </div>
		</nav>
	  </div>
    </section>
	<!--Configurator Section-->
  	<section class="px-4 sm:px-6 lg:px-12 lg:container w-full {secStyle}" id="configurator">
		{#if user}
	  <iframe id="configurator" class="w-full h-screen lg:h-1/2" title="configurator" width="640" height="360"
	 	src="https://pangea.lumiscaphe.com?first_name={user.first_name}&amp;last_name={user.last_name}&amp;user_title={user.title}&amp;user_company={company}&user_email={user.email}" frameborder="0"></iframe>
		 {/if}
  	</section>
  </div>
</div>
<span class="{is_active === 'configurator' ? 'opacity-0 ' : '' }absolute hidden transition delay-200 right-8 bottom-8 lg:flex flex-col items-center justify-center text-white">
  <span class="text-xs uppercase transform {is_active === 'configurator' ? 'translate-y-12' : 'translate-y-0' } transition">Scroll</span>
  <svg width="10" height="80" class="transition transform duration-300 mt-0 {is_active === 'configurator' ? 'scale-0' : 'scale-100' }">
	<use xlink:href="#icon__arrow_down" class="fill-current"/>
  </svg>
</span>
<Footer/>
<Modal url={url} index={index} callback={unsetTimer} unsetModal={unsetModal}/>